import { ProcedureName98 } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
  },
  {
    title: "代行者",
    keyword: "agentUserName",
    type: "selectForm",
    selectPropsList: [],
    fullWidth: false,
    disabled: true,
  },
  {
    title: "代行内容",
    keyword: "agentContent",
    type: "selectForm",
    selectPropsList: TkGetCodeList(ProcedureName98),
    fullWidth: false,
    disabled: true,
  },
  {
    title: "対象施設",
    keyword: "agentFacilityName",
    type: "selectForm",
    selectPropsList: [],
    fullWidth: false,
    disabled: true,
  },
  {
    title: "退職者名",
    keyword: "retirementStaffName",
    type: "nodeInLine",
    disabled: true,
    showLine: false,
  },
  {
    title: "タイトル",
    keyword: "requestTitle",
    type: "label",
    inputProps: { maxLength: 85 },
  },
  {
    title: "対応期日",
    keyword: "dueDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
  },
  {
    title: "本文",
    keyword: "requestContent",
    type: "textarea",
    inputProps: { maxLength: 1000 },
  },
];

const schema = {
  requestTitle: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  dueDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  requestContent: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1,000"),
    },
  },
};

export { fakeTableList, schema };
